export function formatEthAddress(address, startDigits = 4, endDigits = 2) {
    return address.slice(0, startDigits) + "..." + address.slice(address.length - endDigits, address.length);
}